import { NumberingKinds } from "../NumberingKinds";

export class NumberingInformation {
  numberingValue: string;
  numberingKind: NumberingKinds;
  numberingPaddingKind: number;
  numberingPaddingLength: number;
  numberingResetType: number;
  numberingFirstNumber: number;
  numberingPrefix: string;

  clone(): NumberingInformation {
    const cloned = new NumberingInformation();
    cloned.numberingValue = this.numberingValue;
    cloned.numberingKind = this.numberingKind;
    cloned.numberingPaddingKind = this.numberingPaddingKind;
    cloned.numberingPaddingLength = this.numberingPaddingLength;
    cloned.numberingResetType = this.numberingResetType;
    cloned.numberingFirstNumber = this.numberingFirstNumber;
    cloned.numberingPrefix = this.numberingPrefix;
    return cloned;
  }
}
